function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  &:not(:first-child):not(:last-child) {\n    ", " {\n      left: 50%;\n    }\n\n    ", " {\n      left: -50%;\n    }\n  }\n\n  &:last-child {\n    ", " {\n      right: 0;\n    }\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    font-family: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    white-space: nowrap;\n    margin: ", ";\n    color: ", ";\n\n    @media (min-width: ", "px) {\n      font-size: ", ";\n      line-height: ", ";\n    }\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: ", ";\n    display: ", ";\n\n    @media (min-width: ", "px) {\n      display: block;\n      top: ", ";\n    }\n\n    @media (min-width: ", "px) {\n      top: ", ";\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    flex: 1 1 auto;\n    height: 1px;\n    background-color: ", ";\n    margin: ", " ", ";\n\n    @media (min-width: ", "px) {\n      margin: ", " ", ";\n    }\n\n    @media (min-width: ", "px) {\n      margin: ", " ", ";\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: ", ";\n    height: ", ";\n    align-items: center;\n    justify-content: center;\n    border-style: solid;\n    border-width: ", ";\n    border-color: ", ";\n    border-radius: 50%;\n    font-family: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n\n    @media (min-width: ", "px) {\n      width: ", ";\n      height: ", ";\n      font-size: ", ";\n      line-height: ", ";\n\n      svg {\n        width: ", ";\n        height: ", ";\n      }\n    }\n\n    @media (min-width: ", "px) {\n      width: ", ";\n      height: ", ";\n      font-size: ", ";\n      line-height: ", ";\n\n      svg {\n        width: ", ";\n        height: ", ";\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding-bottom: ", ";\n\n    @media (min-width: ", "px) {\n      padding-bottom: ", ";\n    }\n\n    @media (min-width: ", "px) {\n      padding-bottom: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Tick from './Icons/Tick';
import { px2rem } from '../utils/helpers';
var Container = styled('div')(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2(), px2rem(theme.stepBar.container.small.paddingBottom), theme.breakpoints.medium, px2rem(theme.stepBar.container.medium.paddingBottom), theme.breakpoints.xlarge, px2rem(theme.stepBar.container.xlarge.paddingBottom));
});
var Step = styled('div')(_templateObject3(), function (_ref2) {
  var theme = _ref2.theme,
      selected = _ref2.selected,
      future = _ref2.future;
  return css(_templateObject4(), px2rem(theme.stepBar.step.small.width), px2rem(theme.stepBar.step.small.height), !selected ? '1px' : '2px', function () {
    if (selected) return theme.colors.primary1;else if (future) return theme.colors.grey4;
    return theme.colors.black;
  }, theme.text.shared.normal.fontFamily, !selected ? theme.text.shared.normal.fontWeight : theme.text.shared.bold.fontWeight, px2rem(theme.stepBar.step.small.fontSize), px2rem(theme.stepBar.step.small.lineHeight), !future ? theme.colors.black : theme.colors.grey3, theme.breakpoints.medium, px2rem(theme.stepBar.step.medium.width), px2rem(theme.stepBar.step.medium.height), px2rem(theme.stepBar.step.medium.fontSize), px2rem(theme.stepBar.step.medium.lineHeight), px2rem(16), px2rem(16), theme.breakpoints.xlarge, px2rem(theme.stepBar.step.xlarge.width), px2rem(theme.stepBar.step.xlarge.height), px2rem(theme.stepBar.step.xlarge.fontSize), px2rem(theme.stepBar.step.xlarge.lineHeight), px2rem(24), px2rem(24));
});
var Separator = styled('div')(_templateObject5(), function (_ref3) {
  var theme = _ref3.theme,
      future = _ref3.future;
  return css(_templateObject6(), !future ? theme.colors.black : theme.colors.grey4, px2rem(0), px2rem(theme.stepBar.separator.small.marginLeftRight), theme.breakpoints.medium, px2rem(0), px2rem(theme.stepBar.separator.medium.marginLeftRight), theme.breakpoints.xlarge, px2rem(0), px2rem(theme.stepBar.separator.xlarge.marginLeftRight));
});
var LabelContainer = styled('div')(_templateObject7(), function (_ref4) {
  var theme = _ref4.theme,
      selected = _ref4.selected;
  return css(_templateObject8(), px2rem(theme.stepBar.labelContainer.small.top), selected ? 'block' : 'none', theme.breakpoints.medium, px2rem(theme.stepBar.labelContainer.medium.top), theme.breakpoints.xlarge, px2rem(theme.stepBar.labelContainer.xlarge.top));
});
var Label = styled('p')(_templateObject9(), function (_ref5) {
  var theme = _ref5.theme,
      selected = _ref5.selected,
      future = _ref5.future;
  return css(_templateObject10(), theme.text.shared.normal.fontFamily, !selected ? theme.text.shared.normal.fontWeight : theme.text.shared.bold.fontWeight, px2rem(theme.stepBar.label.small.fontSize), px2rem(theme.stepBar.label.small.lineHeight), px2rem(0), !future ? theme.colors.black : theme.colors.grey3, theme.breakpoints.xlarge, px2rem(theme.stepBar.label.xlarge.fontSize), px2rem(theme.stepBar.label.xlarge.lineHeight));
});
var StepContainer = styled('div')(_templateObject11(), LabelContainer, Label, LabelContainer);

function getCSSModifier(index, selected) {
  if (selected === index) {
    return 'selected';
  } else if (index > selected) {
    return 'future';
  }

  return 'previous';
}

function StepBar(props) {
  var steps = props.steps,
      selected = props.selected,
      finalStep = props.finalStep,
      id = props.id;
  return /*#__PURE__*/React.createElement(Container, {
    id: id
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StepContainer, null, /*#__PURE__*/React.createElement(Step, {
      id: id + "__step" + index + "--" + getCSSModifier(index, selected),
      selected: selected === index,
      future: index > selected
    }, index + 1), /*#__PURE__*/React.createElement(LabelContainer, {
      selected: selected === index
    }, /*#__PURE__*/React.createElement(Label, {
      id: id + "__label" + index,
      selected: selected === index,
      future: index > selected
    }, step))), index < steps.length - 1 && /*#__PURE__*/React.createElement(Separator, {
      future: index > selected - 1
    }));
  }), finalStep && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Separator, {
    future: selected < steps.length
  }), /*#__PURE__*/React.createElement(StepContainer, null, /*#__PURE__*/React.createElement(Step, {
    id: id + "__final-step--" + getCSSModifier(steps.length, selected),
    selected: selected >= steps.length,
    future: selected < steps.length
  }, /*#__PURE__*/React.createElement(Tick, {
    size: 13,
    color: selected >= steps.length ? 'black' : 'grey3'
  })), /*#__PURE__*/React.createElement(LabelContainer, null, /*#__PURE__*/React.createElement(Label, {
    id: id + "__final-label",
    selected: selected >= steps.length,
    future: selected < steps.length
  }, finalStep)))));
}

StepBar.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.number.isRequired,
  finalStep: PropTypes.string
} : {};
StepBar.defaultProps = {
  id: 'stepbar',
  finalStep: undefined
};
export default StepBar;